import getApi from '../../../api'
import { STELLAIR_REDIRECT_URI } from '../../../environment/stellair'

export const loginStellair = (code: string, signal?: AbortSignal) =>
  getApi().post(`stellair/login`, { code, redirectUri: STELLAIR_REDIRECT_URI }, { signal })
